import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "@perfectserve/library";
import { extractScheduleNames } from "../../utils/callFlowUtils";
import { formatScheduleName } from "../../utils/scheduleNameUtils";
const ScheduleFilter = ({ isAggregateCard, showScheduleNameFilter, distinctScheduleNames, hasData, selectedScheduleName, setSelectedScheduleName, interactionsExcludingHangups, }) => {
    if (isAggregateCard || !showScheduleNameFilter || distinctScheduleNames.length <= 1 || !hasData) {
        return null;
    }
    return (_jsx("div", { style: {
            marginBottom: "30px",
            fontSize: "12px",
        }, children: _jsxs("div", { className: "d-flex align-items-start", style: { gap: "12px" }, children: [_jsx("span", { style: {
                        fontWeight: "600",
                        color: "#666",
                        minWidth: "75px",
                        marginTop: "7px",
                    }, children: "Schedules:" }), _jsxs("div", { className: "d-flex flex-wrap", style: { gap: "12px" }, children: [_jsxs(Button, { onClick: () => setSelectedScheduleName("All"), variant: selectedScheduleName === "All" ? "primary" : "secondary", size: "small", children: ["All (", interactionsExcludingHangups.length, ")"] }), distinctScheduleNames.map((scheduleName) => {
                            const matchingInteractions = interactionsExcludingHangups.filter((interaction) => {
                                if (!interaction.CallFlow)
                                    return false;
                                const schedules = extractScheduleNames(interaction.CallFlow);
                                return schedules.includes(scheduleName);
                            });
                            const count = matchingInteractions.length;
                            return (_jsxs(Button, { onClick: () => setSelectedScheduleName(scheduleName), variant: selectedScheduleName === scheduleName ? "primary" : "secondary", size: "small", title: `${scheduleName} (${count} interactions)`, children: [formatScheduleName(scheduleName), " (", count, ")"] }, scheduleName));
                        })] })] }) }));
};
export default ScheduleFilter;
//# sourceMappingURL=ScheduleFilter.js.map